var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtsyReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4838c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28539,
    stopColor: "#f46a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#f45800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.3949,29.69855v2.27448l2.89215.61261c2.0932.41864,2.711.83728,2.711,2.69305,0,0,.03571.92188.07819,2.61395.58673-.22198,1.21332-.34943,1.85974-.34943,1.90454,0,3.66675,1.03174,4.599,2.69275l.08466.15088v-6.9588c0-.63818,0-.83728,1.05682-.83984h13.04163c2.2923,0,3.53033,1.85577,4.34723,5.58527l.83728,2.9126h2.27441c.21954-8.2962.41864-11.80615.41864-11.80615,0,0-5.5827.59735-8.89349.59735h-16.59241l-8.71484-.17871Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.86487,42.32153l-.83728,3.33124c-.41864,2.27448-.83728,2.49396-3.11176,2.89221-.05402.00409-.11462.00757-.17035.01154-.04895,1.00531-.37866,1.98523-.97375,2.81635.4458.02332.84229.05017,1.1441.08215,1.65674.1991,2.49402.6203,3.11176,2.69305l.61774,2.91266h2.49396l-.21954-7.45892.41864-7.28027h-2.47351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.24713,70.52094c3.31079,0,11.18835.19916,11.18835.19916.1991-2.05493,1.23547-11.18842,1.45502-12.22479h-2.0932l-2.25403,4.98535c-1.67706,3.92859-4.36761,4.14813-7.06067,4.14813h-8.71484c-2.89221,0-4.14807-1.05682-4.14807-3.53033v-1.64246c-.00519,0-.01019.00079-.01538.00079-.76404,0-1.50598-.16309-2.20471-.48456l-2.46368-1.13306-1.83984.84619c-.05072,2.22821-.09802,3.44946-.09802,3.44946,0,1.65668-.6178,2.27441-2.711,2.69305l-2.89215.63818v2.25403l8.91394-.19916h14.93829Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.44824,49.1673l3.08649,3.34485-.53101,4.5202c-.11597.98761.89392,1.72137,1.7973,1.30579l4.13489-1.90173,4.13501,1.90173c.10309.04742.20734.07581.31134.0946.03223.00586.06366.00708.09576.01038.04211.00427.08466.01367.12628.01367.00525,0,.01013-.00159.01538-.00165v-.00934c.71515-.0097,1.341-.62531,1.24841-1.41345l-.53088-4.5202,1.16888-1.26672h0l1.9176-2.07812c.06793-.07361.12012-.15302.16394-.23505.0401-.06952.06897-.14087.09436-.21405v-.00006h0c.24036-.69202-.15155-1.50507-.94482-1.66364l-3.11755-.62299h0l-1.34546-.26886-2.22742-3.96912c-.06085-.1084-.13354-.20325-.21521-.28455-.16327-.1626-.36237-.27094-.57324-.32513-.10547-.0271-.21387-.04065-.32233-.04065s-.21686.01355-.32233.04065c-.21088.0542-.40997.16254-.57324.32513-.08167.0813-.15436.17615-.21521.28455l-2.22742,3.96912-4.46301.89185c-.9751.19489-1.3609,1.38202-.68652,2.11279Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtsyReviewsScraper);
export default __webpack_public_path__ + "static/media/etsy-reviews-scraper.fcce0c6eb9a3d6fdff62fc24d7c9c22f.svg";
export { ForwardRef as ReactComponent };